import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { CreditCard } from "lucide-react";

export default function PaymentHistory() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/payments/history").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  const currency = (n, c = "usd") => new Intl.NumberFormat("en-US", { style: "currency", currency: c.toUpperCase() }).format(n || 0);
  return (
    <DashboardLayout title="Payment history" subtitle="Every payment attempt, initiated or paid">
      <div className="rounded-xl border border-zinc-800 overflow-hidden" data-testid="payments-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-zinc-500 border-b border-zinc-800 bg-zinc-900/40">
              <th className="p-3">Date</th><th className="p-3">Amount</th><th className="p-3">Status</th>
              <th className="p-3">Kind</th><th className="p-3">Session</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.session_id} className="border-b border-zinc-800 hover:bg-zinc-900/40">
                <td className="p-3 text-zinc-400 text-xs">{p.created_at?.slice(0, 16).replace("T", " ")}</td>
                <td className="p-3 text-zinc-100 font-medium">{currency(p.amount, p.currency)}</td>
                <td className="p-3">
                  <span className={`inline-flex items-center gap-1.5 text-xs ${p.payment_status === "paid" ? "text-emerald-400" : "text-blue-400"}`}>
                    <CreditCard className="w-3 h-3" /> {p.payment_status}
                  </span>
                </td>
                <td className="p-3 text-zinc-500 text-xs">{p.invoice_id ? "invoice" : p.lookup_key ? "subscription" : "—"}</td>
                <td className="p-3 text-zinc-500 text-[11px] font-mono truncate max-w-[240px]">{p.session_id}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-zinc-500">{t("common.no_data")}</td></tr>}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
